(() => {
  const STOREFRONT_TOKEN = "80bb79011aa651eb9847ea3f0db30948";
  const SHOP_DOMAIN = "neverover.com";
  const API_VERSION = "2024-10";

  /* -------------------------------------------
          Helpers 
    ------------------------------------------- */

  const storefrontRequest = async (query, variables) => {
    const res = await fetch(`https://${SHOP_DOMAIN}/api/${API_VERSION}/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query, variables })
    });
    
    return res.json();
  };

  const hide = el => el && (el.style.display = "none");
  const show = el => el && (el.style.display = "flex");
  const hideEl = el => el && (el.style.display = "none");
  const showEl = el => el && (el.style.display = "flex");

  /* ---------------------------------------------
   LOGIN HANDLER
  --------------------------------------------- */

  const handleLogin = async (form) => {
    const emailInput = form.querySelector('[name="customer[email]"]');
    const passwordInput = form.querySelector('[name="customer[password]"]');

    const emailError = emailInput
      ?.closest(".field")
      ?.querySelector(".form_error");

    const passwordError = passwordInput
      ?.closest(".field")
      ?.querySelector(".form_error");

    const invalidError = form.querySelector(
      ".login__btns"
    )?.previousElementSibling; // the last .form_error

    const button = form.querySelector('.login__btn');
    const spanText = button.querySelector('span');
    if(button){
      button.classList.add('is-loading');
      button.disabled = true;
      spanText.textContent = 'logging in…'
    }

    const email = emailInput.value.trim();
    const password = passwordInput.value.trim();

    // Reset all errors
    hide(emailError);
    hide(passwordError);
    hide(invalidError);

    let hasError = false;

    if (!email) {
      show(emailError);
      hasError = true;
      if(button){
        button.classList.remove('is-loading');
        button.disabled = false;
        button.textContent = 'Log in'
      }
    }

    if (!password) {
      show(passwordError);
      hasError = true;
      if(button){
        button.classList.remove('is-loading');
        button.disabled = false;
        button.textContent = 'Log in'
      }
    }

    if (hasError) {
      if(button){
        button.classList.remove('is-loading');
        button.disabled = false;
        button.textContent = 'Log in'
      }
      return;
    };

    /* ---------------------------------------------
     Storefront API validation
    --------------------------------------------- */

    const query = `
      mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
        customerAccessTokenCreate(input: $input) {
          customerAccessToken { accessToken }
          customerUserErrors { message }
        }
      }
    `;

    const result = await storefrontRequest(query, {
      input: { email, password }
    });
    //console.log("Storefront API Full Response:", result);
    const { data } = result;

    const errors = data.customerAccessTokenCreate.customerUserErrors;

    if (errors.length) {
      show(invalidError);
      if(button){
        button.classList.remove('is-loading');
        button.disabled = false;
        button.textContent = 'Log in'
      }
      return;
    }

    /* ---------------------------------------------
     Submit hidden native form (SESSION CREATION)
    --------------------------------------------- */

    const wrapper = form.closest("#login-form-wrappers");
    const nativeForm = wrapper.querySelector(".hidden-login form");

    nativeForm.querySelector('[name="customer[email]"]').value = email;
    nativeForm.querySelector('[name="customer[password]"]').value = password;

    if (window.Shopify?.captcha?.protect) {
      Shopify.captcha.protect(nativeForm, () => nativeForm.submit());
    } else {
      nativeForm.submit();
    }
  };

  const handleRegister = async (form) => {
    // grab inputs
    const firstNameInput = form.querySelector('[name="customer[first_name]"]');
    const lastNameInput = form.querySelector('[name="customer[last_name]"]');
    const emailInput = form.querySelector('[name="customer[email]"]');
    const passwordInput = form.querySelector('[name="customer[password]"]');

    const emailError = emailInput?.closest(".field")?.querySelector(".form_error");
    const passwordError = passwordInput?.closest(".field")?.querySelector(".form_error");
    const globalError = form.querySelector(".global_error");

    // reset UI
    hideEl(emailError);
    hideEl(passwordError);
    hideEl(globalError);

    const firstName = firstNameInput.value.trim();
    const lastName = lastNameInput.value.trim();
    const email = emailInput.value.trim();
    const password = passwordInput.value.trim();

    const button = form.querySelector('.login__btn');
    const spanText = button.querySelector('span');
    if(button){
      button.classList.add('is-loading');
      button.disabled = true;
      spanText.textContent = 'Creating account...'
    }

    // basic validation
    let hasError = false;

    if (!firstName) {
      showEl(firstNameError);
      hasError = true;
    }
    if (!lastName) {
      showEl(lastNameError);
      hasError = true;
    }
    if (!email) {
      showEl(emailError);
      hasError = true;
    }
    if (!password) {
      showEl(passwordError);
      hasError = true;
    }

    if (hasError){
      if(button){
        button.classList.remove('is-loading');
        button.disabled = false;
        spanText.textContent = 'Create account'
      }
      return;
    };

    // prepare mutation
    const query = `
      mutation customerCreate($input: CustomerCreateInput!) {
        customerCreate(input: $input) {
          customer {
            id
          }
          customerUserErrors {
            message
          }
        }
      }
    `;

    // After you get the response from the Storefront API:
    const response = await storefrontRequest(query, {
      input: { firstName, lastName, email, password }
    });

    const globalErrorContainer = form.querySelector(".global_error");
    const globalErrorSpan = globalErrorContainer?.querySelector("span");

    // 1) Check for top-level GraphQL errors first
    if (response.errors && response.errors.length > 0) {
      const topError = response.errors[0];
      const code = topError.extensions?.code;
      const message = topError.message || "Something went wrong!";

      // If throttled, fallback to native form submit
      if (code === "THROTTLED") {
        const wrapper = form.closest("#register-form-wrappers");
        const nativeForm = wrapper.querySelector(".hidden-register form");

        nativeForm.querySelector('[name="customer[first_name]"]').value = firstName;
        nativeForm.querySelector('[name="customer[last_name]"]').value = lastName;
        nativeForm.querySelector('[name="customer[email]"]').value = email;
        nativeForm.querySelector('[name="customer[password]"]').value = password;

        if (window.Shopify?.captcha?.protect) {
          Shopify.captcha.protect(nativeForm, () => nativeForm.submit());
        } else {
          nativeForm.submit();
        }
        return;
      }

      // Otherwise show API message in global error (optional)
      if (globalErrorSpan) {
        globalErrorSpan.textContent = message;
        showEl(globalErrorSpan.parentElement);
      }
      return;
    }

    // 2) Normal mutation user errors
    const userErrors = response.data.customerCreate?.customerUserErrors;
    if (userErrors && userErrors.length > 0) {
      const msg = userErrors[0].message;
      globalErrorSpan.textContent = msg;
      showEl(globalErrorSpan.parentElement);
      globalErrorContainer.classList.add('success');
      globalErrorContainer.setAttribute('data-success','true');
      form.reset();
      if(button){
        button.classList.remove('is-loading');
        button.disabled = false;
        spanText.textContent = 'Create account'
      }
      return;
    }

    // everything looks ok -> submit hidden native form
    const wrapper = form.closest("#register-form-wrappers");
    const nativeForm = wrapper.querySelector(".hidden-register form");

    nativeForm.querySelector('[name="customer[first_name]"]').value = firstName;
    nativeForm.querySelector('[name="customer[last_name]"]').value = lastName;
    nativeForm.querySelector('[name="customer[email]"]').value = email;
    nativeForm.querySelector('[name="customer[password]"]').value = password;

    if (window.Shopify?.captcha?.protect) {
      Shopify.captcha.protect(nativeForm, () => nativeForm.submit());
    } else {
      nativeForm.submit();
    }
  };
  /* ---------------------------------------------
   Bind (supports injected forms)
  --------------------------------------------- */

  const bindLoginForms = () => {

    document.querySelectorAll(".ajax-login form").forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = "true";

      form.addEventListener("submit", e => {
        e.preventDefault();
        handleLogin(form);
      });
    });

    document.querySelectorAll(".ajax-register form").forEach(form => {
      if (form.dataset.boundRegister) return;
      form.dataset.boundRegister = "true";

      form.addEventListener("submit", e => {
        e.preventDefault();
        handleRegister(form);
      });
    });

  };

  bindLoginForms();

  new MutationObserver(bindLoginForms).observe(document.body, {
    childList: true,
    subtree: true
  });

})();
